module.exports = __webpack_public_path__ + "img/twap-30.3b668391.svg";